import type { ReactNode } from 'react';

import './SectionLabel.scss';

interface ISectionLabelProps {
  children: ReactNode;
  className?: string;
  id?: string;
}

const SectionLabel = ({ children, className, id }: ISectionLabelProps) => {
  const rootClass = ['section-label', className].filter(Boolean).join(' ');
  return (
    <div className={rootClass} id={id}>
      {children}
    </div>
  );
};

export default SectionLabel;
